import { render } from "./ClientNotaCredito.vue?vue&type=template&id=10818b0a&scoped=true"
import script from "./ClientNotaCredito.vue?vue&type=script&lang=js"
export * from "./ClientNotaCredito.vue?vue&type=script&lang=js"

import "./ClientNotaCredito.vue?vue&type=style&index=0&id=10818b0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10818b0a"]])

export default __exports__